
// import { reportsList, academydata } from '../config/apiUrl'
import API from '../services';
const { getReportsList, getAcdamyInfo } = API.dataqin

const getReportsData = async (params, _isBrowser) => {
    return new Promise(resolve => {
        reportsList(params, _isBrowser).then((result) => {
            resolve({
                record: result
            })
      })
    })
}

const getacademyData = async () => {
    return new Promise(resolve => {
        academydata().then((result) => {
            resolve({
                record: result
            })
       
        })
    })
}

export default {
    namespace: 'academy',
    state: {
        reportlist: [],
        academydata: {}
    },
    reducers: {
        initReport(state, { payload }) {
            return {
              ...state,
              reportlist: payload
            }
        },
        initAcademyData(state, { payload }) {
            return {
                ...state,
                academydata: payload
              }
        }
    },
    effects: {
        *setReports({ payload }, {put}) {
            yield put({
                type: 'initReport',
                payload: payload.record
            })
        },
        *setPage1({ payload }, {put}) {
            yield put({
                type: 'initAcademyData',
                payload: payload.record
            })
        },
        // 获取论文列表
        *getReportsList({ payload, _isBrowser }, { call, put }) {
            const result = yield call(getReportsList, payload, _isBrowser)
            // 成功
            yield put({
                type: 'initReport',
                payload: result
            })
           
        },
        // 获取头部论文数据
        *getAcademy({ }, { call, put }) {
            const result = yield call(getAcdamyInfo)

            // 成功
            yield put({
                type: 'initAcademyData',
                payload: result
            })
        }
    }
}